document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(() => {
    document.querySelectorAll(".related_prod_slide").forEach(function (slider) {
      if (!slider.classList.contains("splide-initialized")) {
        new Splide(slider, {
          type: "loop",
          perPage: 5,
          perMove: 1,
          gap: "2rem",
          arrows: true,
          pagination: false,
          breakpoints: {
            1024: { perPage: 3 },
            768: { perPage: 2 },
            480: { perPage: 1 },
          },
        }).mount();
        slider.classList.add("splide-initialized");
      }
    });
  });

  const targetNode = document.body;
  const config = { childList: true, subtree: true };
  observer.observe(targetNode, config);
});
